import React from "react"
import IntlProps from "../../../../state/helpers/IntlProps"
import {injectIntl} from "react-intl"
import { imageAndTextRowMessages } from "./messages"
import TextContentInput from "../text/input.component"
import ImageContentInput from "../image/input.component"
import { Content, ContentType, ImageContent, TextContent } from "./types"

interface Props {
    variables: unknown
    cellIndex: number,
    value: {
        cellContent?: Content
        contentType: ContentType
    }
    onChange: (index: number, contentType: ContentType, content?: Content ) => void
}


const InputTextAndImageRow: React.FC<Props & IntlProps> = ({ value = { contentType:ContentType.IMAGE }, ...props }) => {

    const onContentTypeSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        props.onChange(
            props.cellIndex,
            event?.target.value as ContentType,
            value.cellContent,
        )
    }

    // on image and text change the event returns the object with the content details
    const onTextChanged = (content: TextContent) => {
        props.onChange(
            props.cellIndex,
            value.contentType,
            content
        )
    }

    const onImageChanged = (content: ImageContent) => {
        props.onChange(
            props.cellIndex,
            value.contentType,
            content
        )
    }

    const getContentInputByType = (type: ContentType) => {
        switch(type) {
        case ContentType.TEXT: 
            return <TextContentInput variables={props.variables} value={value.cellContent} onChange={onTextChanged}/> 
        case ContentType.IMAGE:
            return <ImageContentInput value={value.cellContent} onChange={onImageChanged}/>
        default :
            return ""
        }
    }
  
    return (
        <div>

            {/* Column # label */}
            <div className="form-group row mb-0">
                <label className="col-12 col-form-label text-align-left mb-0" htmlFor="title">
                    <h4 className="mb-0">
                        <strong>
                            {props.intl.formatMessage(imageAndTextRowMessages.column)}
                            <span> </span>
                            {props.cellIndex + 1}
                        </strong>
                    </h4>
                </label>
            </div>

            {/* Input to select column content : Text or Image */}
            <div className="form-group row">
                <label className="col-2 col-form-label text-align-right" htmlFor="contentType">
                    {props.intl.formatMessage(imageAndTextRowMessages.columnContentType)}
                </label>
                <div className="col-10">
                    <select
                        name="contentType"
                        value={value.contentType}
                        onChange={onContentTypeSelectChange}
                        id="contentType"
                        className="form-control"
                    >
                        <option value="text">{props.intl.formatMessage(imageAndTextRowMessages.contentTypeText)}</option>
                        <option value="image">{props.intl.formatMessage(imageAndTextRowMessages.contentTypeImage)}</option>
                    </select>
                </div>
            </div>

            {/* image or text component */}
            { getContentInputByType(value.contentType) }

        </div>
    )
}

export default injectIntl(InputTextAndImageRow)


// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/InputTextAndImageRow.tsx